import { useState } from "react";
import { collection, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db, FIREBASE_READY } from "../../firebase";
import { useApp } from "../../contexts/AppContext";
import { sSave } from "../../utils/storage";

const blankProj = () => ({ title:"", status:"Planning", year:new Date().getFullYear().toString(), location:"", description:"", published:true });

export default function ProjectsTab({ flash }) {
  const { projects, setProjects } = useApp();
  const [editProj, setEditProj]   = useState(null);
  const [newProj,  setNewProj]    = useState(blankProj());

  const EPJ    = editProj || newProj;
  const setEPJ = v => {
    const next = typeof v === "function" ? v(EPJ) : v;
    editProj ? setEditProj(next) : setNewProj(next);
  };

  const saveProj = async () => {
    const { id: docId, ...projData } = EPJ;
    if (FIREBASE_READY) {
      try {
        if (editProj) await setDoc(doc(db, "projects", docId), projData);
        else          await addDoc(collection(db, "projects"), projData);
      } catch { flash("Error saving project."); return; }
    } else {
      const id = editProj?.id || Date.now();
      const p  = editProj ? { id: docId, ...projData } : { ...projData, id };
      const up = editProj ? projects.map(x => x.id === p.id ? p : x) : [...projects, p];
      setProjects(up);
      sSave("lhda_projects", up);
    }
    setEditProj(null);
    setNewProj(blankProj());
    flash("Project saved!");
  };

  const delProj = async (id) => {
    if (!window.confirm("Delete this project?")) return;
    if (FIREBASE_READY) {
      try { await deleteDoc(doc(db, "projects", id)); } catch { flash("Error deleting."); return; }
    } else {
      const u = projects.filter(p => p.id !== id);
      setProjects(u);
      sSave("lhda_projects", u);
    }
    flash("Project deleted.");
  };

  return (
    <div>
      <div className="acard">
        <div className="atitle">{editProj ? "✏️ Edit Project" : "➕ New Project"}</div>
        <div className="grid2">
          <div className="field"><label>Project Title</label>
            <input value={EPJ.title} onChange={e => setEPJ({ ...EPJ, title:e.target.value })} placeholder="Project title"/>
          </div>
          <div className="field"><label>Year</label>
            <input value={EPJ.year} onChange={e => setEPJ({ ...EPJ, year:e.target.value })}/>
          </div>
        </div>
        <div className="grid2">
          <div className="field"><label>Status</label>
            <select value={EPJ.status} onChange={e => setEPJ({ ...EPJ, status:e.target.value })}>
              {["Planning","In Progress","Pending","Ongoing","Complete"].map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="field"><label>Location</label>
            <input value={EPJ.location} onChange={e => setEPJ({ ...EPJ, location:e.target.value })} placeholder="Project location"/>
          </div>
        </div>
        <div className="field"><label>Description</label>
          <textarea value={EPJ.description} onChange={e => setEPJ({ ...EPJ, description:e.target.value })} rows={5}/>
        </div>
        <div className="row-btns">
          <button className="btn-g" onClick={saveProj}>{editProj ? "Update Project" : "Add Project"}</button>
          {editProj && <button className="btn-gray" onClick={() => setEditProj(null)}>Cancel</button>}
        </div>
      </div>

      <div className="acard">
        <div className="atitle">All Projects <span style={{ fontSize:".75rem", fontWeight:400, color:"var(--gr)" }}>({projects.length})</span></div>
        {projects.map(p => (
          <div key={p.id} className="pi-row">
            <div>
              <div className="pi-title">{p.title}</div>
              <div className="pi-meta">{p.year} · {p.status} · {p.location}</div>
            </div>
            <div className="pi-acts">
              <button className="btn-b" onClick={() => { setEditProj({ ...p }); window.scrollTo({ top:0, behavior:"smooth" }); }}>Edit</button>
              <button className="btn-r" onClick={() => delProj(p.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
